module.exports = __webpack_public_path__ + "static/CERT_27001-EN_Cool_Harbour_2024-e2a12c4025e3fca52c72197a29c8496e.pdf";